import React from 'react';
import P from '../../typography/P';
const InputError = ({ children, id, styles }) => (React.createElement(P, { role: "alert", id: id, size: "small", styles: styles }, children));
export default InputError;
//# sourceMappingURL=index.js.map